var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Widget, WidgetGroup } from '@easyquery/core';
/**
 * The widget responsed for rendering statement.
 * It's usually added for demonstration purposes only.
 */
var StatementPanel = /** @class */ (function (_super) {
    __extends(StatementPanel, _super);
    /**
     * The  default constructor.
     * @param slot The html element.
     */
    function StatementPanel(slot) {
        var _this = _super.call(this, slot) || this;
        _this.panel = slot;
        _this.group = WidgetGroup.Statement;
        if (_this.panel.tagName !== "TEXTAREA") {
            _this.panel.innerHTML = '<div class="eqv-sql-panel-result"></div>';
            _this.panel = _this.panel.querySelector('div');
        }
        return _this;
    }
    StatementPanel.prototype.getWidgetType = function () {
        return 'statementPanel';
    };
    /**
     * Refresh widget implementation
     */
    StatementPanel.prototype.refreshCore = function () {
        this.clear();
        this.render();
    };
    StatementPanel.prototype.render = function () {
        this.panel.textContent = this.context.resultStatement ? this.context.resultStatement : "";
        var statementText = this.panel.innerHTML.replace(/\r\n/g, "<br />").replace(/  /g, "&nbsp;&nbsp;");
        this.panel.innerHTML = statementText;
    };
    StatementPanel.prototype.destroyCore = function () {
        this.clear();
    };
    StatementPanel.prototype.clear = function () {
        this.panel.innerHTML = "";
    };
    return StatementPanel;
}(Widget));
export { StatementPanel };
//# sourceMappingURL=statement_panel.js.map